var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.52246 8.5H8.92996L8.71996 8.2975C9.45496 7.4425 9.89746 6.3325 9.89746 5.125C9.89746 2.4325 7.71496 0.25 5.02246 0.25C2.32996 0.25 0.147461 2.4325 0.147461 5.125C0.147461 7.8175 2.32996 10 5.02246 10C6.22996 10 7.33996 9.5575 8.19496 8.8225L8.39746 9.0325V9.625L12.1475 13.3675L13.265 12.25L9.52246 8.5ZM5.02246 8.5C3.15496 8.5 1.64746 6.9925 1.64746 5.125C1.64746 3.2575 3.15496 1.75 5.02246 1.75C6.88996 1.75 8.39746 3.2575 8.39746 5.125C8.39746 6.9925 6.88996 8.5 5.02246 8.5Z",
    fill: "#838489"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.6a27a127122ea36bf0c6cb38050ae6d8.svg";
export { ForwardRef as ReactComponent };